// removed by extract-text-webpack-plugin
module.exports = {"red":"#e40000","grey":"#707070","textBlock":"_32TKaG8IuzBTrWjuV1cV3i","textSamples":"_1ux-bNxxI2xDlTBSseah_i","totalsTable":"_36HfxUa1-qssg_sz-zU4df"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/foundations/TextStyles/TextStylesUsage/TextStylesUsage.css
// module id = 789
// module chunks = 0